const { $ } = window

//standardize

export default {
   // JavaScript to be fired on all pages
   init() {
      // if iubenda is not used
      generateInPageNavigation()
      handleMobileInPageNav()

      // if iubenda is used
      // waitForElementToBeAdded('#iub-pp-container')
      //   .then(function (element) {
      //     $('#iub-pp-container h1').hide()
      //   })
      //   .catch(function (error) {
      //     console.error(error.message)
      //   })
      //   .finally(function () {
      //     generateInPageNavigation()
      //     handleMobileInPageNav()
      //   })
   },
   // JavaScript to be fired on body.legal pages, after page specific JS is fired
   finalize() {},
}

function generateInPageNavigation() {
   const $nav = $('.legal--in-page-nav--menu')
   const sectionHeadings = document.querySelectorAll('.legal--contents-wrap h2')

   //dynamically generate a link for each h2
   // let count = 0
   sectionHeadings.forEach((h2) => {
      const a = document.createElement('a')
      //arrow for active entry
      a.innerHTML = `<svg aria-hidden="true" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-2.94264e-07 5.27047L11.0014 5.27046L6.75874 1.04123L7.78928 -0.00269352L13.7852 6.00657L7.78928 12.0024L6.75874 10.9853L11.0014 6.74267L-2.29912e-07 6.74267L-2.94264e-07 5.27047Z" fill="#193F5B"/></svg>`
      a.innerHTML += `<span>${h2.innerText}</span>`
      const id = h2.innerText.toLowerCase().replace(/\s+/g, '-')
      h2.id = id
      a.id = id + '--link'
      a.href = `#${id}`
      a.classList.add('legal--in-page-nav--menu-link')

      // if (count == 0) {
      //   a.classList.add('active')
      // }

      const li = document.createElement('li')
      li.classList.add('legal--in-page-nav--menu-item')
      li.appendChild(a)
      $nav.append(li)

      // count++
   })

   // load as disabled for listening to page scroll until proper anchor link section associated is scrolled to
   let enableScrolling = false
   setTimeout(() => {
      enableScrolling = true
      checkPosition()
   }, 200) //time-based substitution

   const navbarHeight = document
      .querySelector('.site-header')
      .getBoundingClientRect().height

   function checkPosition() {
      if (enableScrolling) {
         for (const h2 of sectionHeadings) {
            if (navbarHeight < h2.getBoundingClientRect().bottom) {
               if (!activeId.includes(h2.id)) {
                  $inPageNavAnchors.each((_, item) => {
                     item.classList.remove('active')
                  })
                  activeId = h2.id
                  activeAnchor = document.querySelector(
                     `a[id="${activeId}--link"]`
                  )
                  activeAnchor.classList.add('active')
               }
               break
            }
         }
      }
   }

   //on page load, get section from URL
   let activeId = location.hash.slice(1)
   if (!activeId) {
      activeId = sectionHeadings[0].id
   }
   const $inPageNavAnchors = $('.legal--in-page-nav--menu-link')

   let activeAnchor = document.querySelector(`a[id="${activeId}--link"]`)
   activeAnchor.classList.add('active')

   document.onscroll = () => checkPosition() //TODO

   let t
   $inPageNavAnchors.on('click', function (e) {
      enableScrolling = false
      clearTimeout(t)
      $inPageNavAnchors.removeClass('active')
      e.target.parentNode.classList.add('active')
      t = setTimeout(() => {
         enableScrolling = true
      }, 1000)
   })
}

function handleMobileInPageNav() {
   const $active = $('.legal--in-page-nav--active')

   $active.on('click', function () {
      $active.toggleClass('active')
   })

   $('.legal--in-page-nav--menu-link').each(function () {
      $(this).on('click', function () {
         $active.hasClass('active') && $active.removeClass('active')
         $active.find('span').text($(this).find('span').text()) //update mobile on scroll
      })
   })

   $(window).on('click', function (e) {
      if (
         !e.target.closest('.legal--in-page-nav') &&
         $active.hasClass('active') //?
      ) {
         $active.removeClass('active')
      }
   })
}

function waitForElementToBeAdded(selector, interval = 50, timeout = 1000) {
   return new Promise(function (resolve, reject) {
      var startTime = Date.now()

      function checkForElement() {
         var element = document.querySelector(selector)

         if (element) {
            clearInterval(intervalId)
            resolve(element)
         } else if (Date.now() - startTime > timeout) {
            clearInterval(intervalId)
            reject(new Error('Timeout waiting for element'))
         }
      }

      var intervalId = setInterval(checkForElement, interval)
      checkForElement() // Check for the element immediately
   })
}
